// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"354":"project","530":"page","597":"projects","757":"not-found","841":"studio","946":"news","962":"home"}[chunkId] || chunkId) + "." + {"45":"f57f9f79","354":"7e871d84","530":"e08e7ae5","597":"b7e735fe","757":"1c848060","841":"8105da66","946":"065eb29c","962":"5650f835"}[chunkId] + ".js";
};